import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {GeneralFormComponent} from '../../general/form/generalForm.component';
import {MessageService} from '../../../../shared/message.service';
import {QuestionService} from '../../../services/question.service';
import {QuestionControlService} from '../../../services/question-control.service';
import {AdditionalRightService} from '../../../services/additional-right.service';
import {AdditionalRight} from '../../../interfaces/additionalRight';

@Component({
  selector: 'app-additional-right-details',
  templateUrl: '../../general/form/generalForm.component.html',
  styleUrls: ['../../general/form/generalForm.component.css']
})
export class AdditionalRightFormComponent extends GeneralFormComponent<AdditionalRight> implements OnInit {

  public additionalRights: AdditionalRight[];

  constructor(
    route: ActivatedRoute,
    location: Location,
    messagesService: MessageService,
    router: Router,
    questionService: QuestionService,
    questionControlService: QuestionControlService,
    private additionalRightService: AdditionalRightService
  ) {
    super(route, additionalRightService, location, messagesService, router, questionService, questionControlService,
      {
        entityNameSingular: 'additional right',
        entityNamePlural: 'additional rights',
        formUrl: 'additionalright',
        listUrl: 'additionalrights',
        generalFormMetaName: 'additional-right'
      });
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
  }
}
